import { useAuthStore } from "../../store/authStore";

export function PlanBanner() {
  const me = useAuthStore((s) => s.me);
  if (!me) return null;
  if (me.plan.showPastDueBanner) {
    return (
      <div className="plan-banner" data-testid="plan-banner">
        Payment past due — update billing to keep writing.
      </div>
    );
  }
  if (me.plan.readOnly) {
    return (
      <div className="plan-banner" data-testid="plan-banner">
        Read-only plan — export and billing still work.
      </div>
    );
  }
  if (me.plan.planId === "free") {
    return (
      <div className="plan-banner" data-testid="plan-banner">
        Free plan — limited loads. Upgrade in Settings → Plan.
      </div>
    );
  }
  return null;
}
